import React from "react";
import getSearchResultsCountSelector from "../../../../../state/selectors/SearchSelectors/getSearchResultsCountSelector";
import isSearchingSelector from "../../../../../state/selectors/SearchSelectors/isSearchingSelector";
import styled from "styled-components";
import { useSelector } from "react-redux";

function counterize(counter: number, singular: string, empty: string, plural: string) {
    if (counter === 0) return empty;
    if (counter === 1) return singular;
    return [counter, plural].join(" ");
}

const SearchResults: React.FC = () => {
    const isSearching = useSelector((state: Store) => isSearchingSelector(state));
    const { total, profession, school } = useSelector((state: Store) => getSearchResultsCountSelector(state));
    if (isSearching) return <H3>Ricerca in corso...</H3>;
    if (!total) return <H3>Nessun risultato trovato!</H3>;
    return (
        <H3>
            {counterize(total, "Un risultato trovato", "Nessun risultato trovato!", "risultati trovati")}
            <div>
                <span>
                    {counterize(profession, "Un profilo professionale", "Nessun profilo professionale", "profili professionali")} e{" "}
                    {counterize(school, "una scheda informativa", "nessuna scheda informativa!", "schede informative")}
                </span>
            </div>
        </H3>
    );
};

export default SearchResults;

const H3 = styled.h3`
    position: sticky;
    top: 4rem;
    background-color: #e6e6e6;
    margin: 0;
    padding: 1rem 0.5% 1.3rem 0.5%;
    width: 101%;
    margin-left: -0.5%;
    span {
        font-weight: 400;
        font-size: 1rem;
    }
`;
